import { useSelector } from "react-redux"
import Banner from "@/component/banner"
import BannerForm from "@/component/form/bannerForm"
import Environment from "@/pages/home/components/environment"
import Campus from "@/pages/home/components/campus"
import { Feature } from "@/pages/fudu/index"
import { Material } from "@/pages/jiaoxue/index"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

function Index() {
  const classnames = classModuleGenerator(styles)
  const banners = [
    {
      imageUrl: require("@/assets/images/banner-img.png"),
      intro: "精细培养教师能力，定期考核教学质量",
      name: "严格筛选教师资质",
      _id: "teaching",
    },
  ]
  const { photos } = useSelector((state) => state.page)
  const teacers = [
    {
      name: "执教中多为考核",
      intro: "教师历经严格筛选多层考核",
    },
    {
      name: "培训考核",
      intro: "熟知新课标新课改教育政策",
    },
    {
      name: "试讲考核",
      intro: "多年艺考带班教学经验丰富",
    },
    {
      name: "面试考核",
      intro: "师资团队深受学生欢迎更懂学生",
    },
    {
      name: "笔试考核",
      intro: "实时同步集团全国艺考教研教学体系",
    },
    {
      name: "资质审核",
      intro: "",
    },
  ]

  return (
    <div className="teaching">
      <Banner banners={banners}>
        <BannerForm
          classname="jixun"
          name="立即获取专属冲刺计划"
          title="高考冲刺的晴班"
          stitle="定制化学习方案，快速查缺补漏"
        />
      </Banner>
      <section className={classnames("arrangement-container")}>
        <div className="section__inner">
          <div className={classnames("arrangement-nav")}>
            <h4>每日安排</h4>
            <h4>阶段管理</h4>
          </div>
          <table>
            <tbody>
              <tr>
                <th>时间</th>
                <th>具体安排</th>
                <th>每天</th>
                <th>每周</th>
                <th></th>
              </tr>
              <tr>
                <td>6:30-7:25</td>
                <td>起床，早锻炼，早餐</td>
                <td>每堂课点名签到</td>
                <td>每周评估学习情况</td>
                <td>每月评估学习情况</td>
              </tr>
              <tr>
                <td>7:30-8:30</td>
                <td>早读，早练</td>
                <td>记录学生上课情况</td>
                <td>学生心理1v1疏导</td>
                <td>每月召开学生家长会</td>
              </tr>
              <tr>
                <td>8:35-12:05</td>
                <td>上午4节课</td>
                <td>师生之间沟通反馈</td>
                <td>每周召开班级会议</td>
                <td>针对性进行许学习方案</td>
              </tr>
              <tr>
                <td>12:05-14:00</td>
                <td>午饭，午练，午休</td>
                <td>任课老师自习课答疑</td>
                <td>检查手机等电子产品</td>
                <td>持续优化教学计划</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>班主任进行作业检查</td>
                <td>宿管检查卫生评比公式</td>
                <td>心理减压谈会</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className={classnames("teachers-container")}>
        <h3 className="section__title">学大全日制实力师资团队</h3>
        <div className="section__inner">
          <div className={classnames("teachers-wrap")}>
            <div className={classnames("teachers-img")}></div>

            <ul className={classnames("teachers-content")}>
              {teacers.map((m) => (
                <li key={m.name}>
                  <h5>{m.name}</h5>
                  <p>{m.intro}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Feature></Feature>
      <Material />
      <Environment photos={photos} />
      <Campus />
    </div>
  )
}

export default Index
